import { RoadieApiResponse } from 'roadie-ui'
import type { TranslationKey } from 'localization'

export type CaseType = 'idv' | 'appeal'

export const CaseStatusKeyMap: Record<string, TranslationKey> = {
  new: 'dweb_common_submitted',
  assigned: 'dweb_salesforce_case_status_in_review',
  'in progress': 'dweb_salesforce_case_status_in_review',
  'transferred- in progress': 'dweb_salesforce_case_status_in_review',
  'on hold': 'dweb_salesforce_case_status_in_review',
  merged: 'dweb_salesforce_case_status_in_review',
  pending: 'dweb_salesforce_case_status_pending_driver_reply',
  closed: 'dweb_salesforce_case_status_not_approved',
}

export interface SalesforceCase {
  case_number: string | null
  case_type: CaseType | null
  description: string | null
  origin: string | null
  priority: string | null
  rich_description: string | null
  state: string | null
  status: string | null
  subject: string | null
  date_submitted: string | null
  last_updated: string | null
  case_id: string | null
  inquiry_id: string | null
  support_id: string | null
  profile_id: string | null
  gig_id: string | null
  rich_description_present: boolean | null
}

// Gets the most recently updated open case of a given type
export const getLastUpdatedOpenCase = (data: RoadieApiResponse, case_type: CaseType) => {
  const appealCases = (data.data?.salesforce_cases || []).filter(
    (c: SalesforceCase) => c.case_type === case_type && (c.status ?? '').toLowerCase() !== 'closed'
  )

  const mostRecentAppeal = appealCases.sort(
    (a: { last_updated: string | number | Date }, b: { last_updated: string | number | Date }) =>
      new Date(b.last_updated).getTime() - new Date(a.last_updated).getTime()
  )[0]

  return mostRecentAppeal || null
}
